import { NavLink } from "react-router-dom";
import { useCan } from "@/auth/permissions";

/** 权限管理模块 Tab 栏（canvas 4 子页：用户管理 / 角色管理 / 权限矩阵 / 审计日志）
 *  + 🗑️ 回收站（A6·仅 tech_admin 可见·和审计日志同级）*/
const TABS: { to: string; label: string; end?: boolean }[] = [
  { to: "/admin/permissions", label: "用户管理", end: true },
  { to: "/admin/permissions/roles", label: "角色管理" },
  { to: "/admin/permissions/matrix", label: "权限矩阵" },
  { to: "/admin/permissions/audit-logs", label: "审计日志" },
];

export function RbacTabs() {
  const isTechAdmin = useCan("system.trash.manage"); // 回收站入口：仅有「回收站」权限点的人（默认只有技术管理员）
  const tabs = isTechAdmin
    ? [...TABS, { to: "/admin/permissions/trash", label: "🗑️ 回收站" }]
    : TABS;
  return (
    <div className="-mt-1 flex flex-wrap gap-1 border-b border-slate-200">
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            `-mb-px border-b-2 px-4 py-2 text-[13px] font-medium transition ${
              isActive
                ? "border-blue-600 text-blue-700"
                : "border-transparent text-slate-500 hover:text-slate-700"
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
